import * as React from 'react';
import { Field } from 'redux-form';
export const RadioButtons = ({ name, options, className }) => (
  <div className={`radio-buttons`}>
    <Field
      component={({ input, meta: { touched, error } }) => (
        <div className={className}>
          {options.map(option => (
            <div key={option.id} className={`radio-input ${option.value === input.value ? 'optionSelected' : ''}`}>
              <input
                id={option.id}
                type="radio"
                {...input}
                value={option.value}
                checked={option.value === input.value}
              />
              {!option.image && <label htmlFor={option.id}>{option.label}<br/>{option.label2}</label>}
              {option.image && <label htmlFor={option.id}><img src={option.image} alt={option.label} /> {option.label}<br/>{option.label2}</label>}
            </div>
          ))}
          {touched && error && <span className="error">{error}</span>}
        </div>
      )}
      name={name}
      options={options}
    />
  </div>
);
